import { Component, OnInit , EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;


@Component({
  selector: 'app-product-information-basic',
  templateUrl: './product-information-basic.component.html',
  styleUrls: ['./product-information-basic.component.scss']
})
export class ProductInformationBasicComponent implements OnInit {

  
  modelForm: FormGroup;
  pageName = "Add New Product";
  modelName = "Product";

  toppingList: string[] = ['Womens', 'Mans', 'Girls', 'Boys', 'Kids', 'Infant'];

  @Input() dataModel;
  @Input() dataModelId;
  @Output() formSubmitted = new EventEmitter<any>();


  localModelDataStorage = false;
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  loading = true

  departments = []
  categories = []
  subcategories = []

  selectedDeptId = "";
  selectedCategoryId = "";
  selectedCategories = [];
  selectedSubCategories = [];
  selectedSubCategoryVariations = [];
  catalogueReady = false

  private name1;

  filesToUpload: Array<File> = [];
  sizes: FormArray;

  constructor(
    //private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {}

  ngOnInit() {


    this.modelData = this.dataModel;
    this.modelId = this.dataModelId;

    console.log(this.dataModel)

    this.getDepartments()

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

  	this.modelForm = this.formBuilder.group({

      name: ['', Validators.required], //Product name
      description: ['', Validators.required], 
      specification: ['', Validators.required], 
      department: ['', Validators.required], 
      categories: ['', Validators.required], 
      sub_categories: ['', Validators.required],
      variations: [''],
      brand: [''],

    });

    this.prepopulate();

  }

  get f() { return this.modelForm.controls; }

  prepopulate(){

    for (var key in this.modelData) {  // 'field' is a string

      if (this.modelData[key] instanceof Array || this.modelData[key] instanceof Object) {
    
        var innerModelDataObject;

        if (this.modelData[key] instanceof Object) {
          innerModelDataObject = Object.values(this.modelData[key]);

          var innerModelDataObject2 = this.modelData[key];
          console.log(innerModelDataObject2);

          for (const [objectKey, value] of Object.entries(this.modelData[key])) {
            console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

            for (const objectfield in this.modelForm.controls) {

              if(this.modelData[key][objectfield]) {
    
                this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield]);
                console.log(objectfield);
              }

              if(objectfield == 'variations' && key == 'productDetails') {
                this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield].split(","));
                // let selected = this.modelData[key][objectfield]

                // console.log(key)

              }
    
            }
          }
        }

        //not sure what to do with arrays as yet...

        if (this.modelData[key] instanceof Array) {

          // for (var objectKey in this.modelData[key]) {

          //   alert('value is Array!'+ objectKey);

          // }
        }
        
        
      }

      else {

        for (const field in this.modelForm.controls) {
          // console.log(key)
          if(this.modelData[field]) {

            this.modelForm.get(field).setValue(this.modelData[field]);
            //const control = this.modelForm.get(field); // 'control' is a FormControl
            // console.log(field);
  
            //console.log(control);
          }

        }

      }

      

    }
}


  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Create Product ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createProduct(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getDepartments() {

    $('#loader').show();

    let queryData = new FormData();
    queryData.append('modelName', "Departments");

    //lets get the model for this page
    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.departments = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['departmentDetails']['category_status'] === "active");
        }

      },
      error => {},
      () => {
          this.getCategories()
      }
    );
  }

  getCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "ShopCategory");

    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.categories = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] === "active");
        }

        this.loading = false

      },
      error => {
      },

      () => {
          this.getSubCategories()
      }
    );

  }
  
  getSubCategories() {

    let queryData = new FormData();
    queryData.append('modelName', "SubCategory");
    this._data.getModelDataShopModels(queryData) 
    .pipe(first())
    .subscribe(
      data => {
        
        if(data['covers'].length > 0) {
          this.subcategories = data['covers'].filter(prod => prod['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['category_status'] === "active");
        }

        this.catalogueReady = true
        console.log(this.subcategories)
        $('#initialise-page').trigger('click');
      },
      error => {
        $('#loader').hide();
      },

      () => {
        $('#loader').hide();
      }
    );

  }

  createProduct() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    modelObject1.append('productDetails-name', this.modelForm.controls['name'].value);
    modelObject1.append('productDetails-description', this.modelForm.controls['description'].value);
    modelObject1.append('productDetails-specification', this.modelForm.controls['specification'].value);
    modelObject1.append('productDetails-department', this.modelForm.controls['department'].value);
    modelObject1.append('productDetails-categories', this.modelForm.controls['categories'].value);
    modelObject1.append('productDetails-sub_categories', this.modelForm.controls['sub_categories'].value);
    modelObject1.append('productDetails-variations', this.modelForm.controls['variations'].value);
    modelObject1.append('productDetails-departmentId', this.selectedDeptId);
    modelObject1.append('productDetails-categoryId', this.selectedCategoryId);

    for (let index = 0; index < this.selectedCategories.length; index++) {
      const element = this.selectedCategories[index];

      if(element['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name'] == this.modelForm.controls['categories'].value) {

        modelObject1.append('productShipping-weight', element['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['weight']);
        modelObject1.append('productShipping-length', element['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['length']);
        modelObject1.append('productShipping-width', element['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['width']);
        modelObject1.append('productShipping-height', element['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['height']);
        break;

      }
      
    }

    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;

          this.modelId = data['result']['id'];
          this.modelData = data['result']['model']['modelData']['formFieldsEntities'];
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));
        },
        error => {
          console.log(error);

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

        },

        () => {

          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your product updated successfuly.'
          });

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
          let details = {
            step : "information",
            data : this.modelData,
            completed : true,
            next: "pricing",
            dataModel: this.modelData,
            modelId: this.modelId
          }
          this.formSubmitted.emit(details);
            
        }
      );
  }

  viewGallery()
  {
  	this.router.navigate(['/sellers/account/product-gallery']);
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed

    // if (changes['dataModel']) {
    //   alert('data changes')
    //   console.log(changes['dataModel'].currentValue)
    //   this.modelData = changes['dataModel'].currentValue;
    //   this.prepopulate();
    // }
   
  }


  filterDepartmentCategories(name) {
    let depts = this.departments.filter(deptCat => deptCat['cover']['model']['modelData']['formFieldsEntities']['departmentDetails']['name'] == name);

    if(depts.length > 0) {
      this.selectedCategories = this.categories.filter(deptCat => deptCat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['store_department'] == depts[0]['id']);
      this.selectedDeptId = depts[0]['id'];
    }

    else {
      this.selectedCategories = []
    }
  }

  filterSubCategories(name) {
    let cats = this.categories.filter(deptCat => deptCat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name'] == name);

    if(cats.length > 0) {
      this.selectedSubCategories = this.subcategories.filter(deptCat => deptCat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['store_department_category'] == cats[0]['id']);
      this.selectedCategoryId = cats[0]['id'];
    }

    else {
      this.selectedSubCategories = []
    }
  }

  filterSubCategoryVariations(name) {
    let cats = this.subcategories.filter(deptCat => deptCat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['name'] == name);

    if(cats.length > 0 && cats[0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['produc_variations_tags'] != undefined && cats[0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['produc_variations_tags'] != "") {
      this.selectedSubCategoryVariations = cats[0]['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['produc_variations_tags'];
      
    }

    else {
      this.selectedSubCategoryVariations = []
    }
  }

  

  filterSubCategoris(parentCatId) {
    return this.subcategories.filter(cat => cat['cover']['model']['modelData']['formFieldsEntities']['categoryDetails']['store_department_category'] == parentCatId);
  }

  chooseSubCategory() {

  }

}
